// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-image-cta__title{margin-bottom:var(--spacing-sm)}@media screen and (min-width:769px){.text-image-cta__title{margin-bottom:var(--spacing-3xl)}}.text-image-cta__button{margin-top:var(--spacing-sm)}@media screen and (min-width:769px){.text-image-cta__button{margin-top:var(--spacing-xl)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
